$(document).ready(function () {
    //https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    // a polyfill for IE to work right with resize events as per below
    //return false; 
    (function () {
      if ( typeof window.CustomEvent === "function" ) return false;
      function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
       }
      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent;
    })();
    
    // footer fix
    $('#footer-support ul.footer_menu li:nth-child(3) a').replaceWith('<a href="/pages/contact-us" id="footer-mail-fix"><span>✉ help@</span><span>99tux.com</span></a>')
    
    $('#footer-support ul.footer_menu li:nth-child(1) a').attr('itemprop','telephone')
    
    if ($('form.shopify-product-form .swatch_options .swatch').length ) { // is there a color selector anywhere
        var shopifyProductForms = $('form.shopify-product-form');
        $.each(shopifyProductForms, function (index) {
            if (shopifyProductForms.eq(index).find('.select > label').eq(0).text() === 'Color') {
                shopifyProductForms.eq(index).find('.select').hide();
            } 
        });

        //if ( $('form.shopify-product-form .select > label').eq(0).text() === 'Color' ) {
        //    $('form.shopify-product-form .select').hide();
        //}
        
        //$(document).on('click', function () {
       $('#shopify-section-product-template div.product_gallery ol li').on('click', function () {
            var productIndex = $(this).index();
            $('form.shopify-product-form .swatch_options .swatch .swatch-element').eq(productIndex).find('label').click();
        });
        $('ol.flex-control-nav.flex-control-thumbs li').on('touchend', function () {
             var productIndex = $(this).index();
             $('form.shopify-product-form .swatch_options .swatch .swatch-element').eq(productIndex).find('label').click();
         });
    }
    
    // Left-right keyboard fixes
    if ($('#shopify-section-product-template').length > 0) {
        var moveColorBox = function (direction) {
            setTimeout(function () { // its a tad slow but always seems to stay in sync
                var currentIndex = $('#shopify-section-product-template ol.flex-control-nav.flex-control-thumbs li img.flex-active').index('#shopify-section-product-template ol.flex-control-nav.flex-control-thumbs li img');
                $('form.shopify-product-form .swatch_options .swatch .swatch-element').eq(currentIndex).find('label').click();
            }, 400);
        };
        
        // Set thumbnail alt text
        $('#shopify-section-product-template ol.flex-control-nav.flex-control-thumbs li img').attr('alt', 'Product Thumbnail');
        
        $(document).keydown(function(e) {
            switch(e.which) {
                case 37: // left
                    moveColorBox('left')
                break;
                case 38: // up
                break;
                case 39: // right
                    moveColorBox('right')
                break;
                case 40: // down
                break;
                default: return; // exit this handler for other keys
            }
            e.preventDefault(); // prevent the default action (scroll / move caret)
        });
        
        
    }
    
    
    //http://www.jacklmoore.com/zoom/
    var featuredImageContainer = $('a.product-page-zoomer-link div.image__container');
    var featuredImage = featuredImageContainer.find('img');
    var img = $('a.product-page-zoomer-link div.image__container img');
    var displayZoomable = function (featuredBlock) {
        if (featuredBlock !== undefined) {
            featuredBlock.wrap('<span style="display:inline-block;width:100%;"></span>').css('display', 'block').parent().zoom();
            featuredBlock.find('img[role=presentation]').attr('alt', "Zoomed Product Image")
        }
        return false;
    };
    
    img.on('load', function () {
        displayZoomable($(this));
        return false;
    });
    
    var undisplayZoomable = function () {
        featuredImageContainer.find("img[role='presentation']").remove();
        featuredImage.unwrap();
    }; 
    
    //https://developer.mozilla.org/en-US/docs/Web/Events/resize
    var optimizedResize = (function() {
      var callbacks = [],
          running = false;
      // fired on resize event
      function resize() {
        if (!running) {
          running = true;

          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(runCallbacks);
          } else {
            setTimeout(runCallbacks, 66);
          }
        }
      }

      // run the actual callbacks
      function runCallbacks() {
        callbacks.forEach(function(callback) {
          callback();
        });

        running = false;
      }

      // adds callback to loop
      function addCallback(callback) {
        if (callback) {
          callbacks.push(callback);
        }
      }

      return {
        // public method to add additional callback
        add: function(callback) {
          if (!callbacks.length) {
            window.addEventListener('resize', resize);
          }
          addCallback(callback);
        }
      }

    }());

    // start process
    optimizedResize.add(function() {
        undisplayZoomable();
        displayZoomable(featuredImageContainer.find('> img'));
    });
    
    
    // prevent any default link clicks
    $('.product-page-zoomer-link').on('click', function (e) {
       e.preventDefault()
       return false;
    });



    // always reset selector on load. 
    // onload, if hemmed, add in 
    var locationHash = window.location.hash.substring(1);
    if(locationHash)  {
        var hashValue = parseFloat(locationHash);
        if ( $.isNumeric(hashValue) === true) {
            $('form.shopify-product-form.hemmedpants').find('.selector-wrapper:eq(1) select option:eq(1)').prop('selected', true);
            $('form.shopify-product-form.hemmedpants').find('.selector-wrapper:eq(1) select').trigger('change');
            //$('form.shopify-product-form').find('select option:eq(0)').prop('selected', true);
            var hemmingOptions = $('form.shopify-product-form.hemmedpants').find('.selector-wrapper:eq(2) select option');
            
            hemmingOptions.each(function (i) {
                if ( parseFloat($(this).val() ) === hashValue) {
                    $(this).prop('selected', true);
                    return false;
                } 
            });
        }
    } 
    
    $('#hemmed-length').on('change', function () {
        var hemSelectChanged = $(this);
        var hemValue = hemSelectChanged.val();
        
        // set Hash
        if (hemValue === 'unhemmed') {
            location.hash = 'U';
        } else {
            location.hash = hemValue;
        }
        
        var form = hemSelectChanged.parents('form.shopify-product-form');
        var hiddenLengthSelector = form.find('.select > .selector-wrapper:nth-child(2)').find('select');
        
        if (hemValue === 'unhemmed') {
            hiddenLengthSelector.find('option:eq(0)').prop('selected', true) 
        } else {
            hiddenLengthSelector.find('option:eq(1)').prop('selected', true) 
            // set length to hemmed
        }
        hiddenLengthSelector.trigger('change');
      return false;
    });
    
    var openLiveChat = function () {
        olark('api.box.expand');
        return false;
    };

    // Contact us page live chat
    $('#contact-live-chat').on('click', function () {
        openLiveChat();
        return false;        
    });
    
    $('.contact-live-chat').on('click', function () {
        openLiveChat();
        return false;
    });
    
    // Adds event handler to open olark chat box for Live Chat Link in header support menu
    $('#shopify-section-header ul.main.menu > li').eq(5).find('ul.animated > li').eq(1).on('click', function () {
        openLiveChat();
        return false;
        
    });
    
    // Adds event handler to open olark chat box for Live Chat Link in header mobile support menu
    $('#shopify-section-header .mobile_menu > li').eq(6).find('ul > li').eq(1).on('click', function () {
        openLiveChat();
        return false;
        
    });
    
    // adds event handler to footer live chat link 
    $('div.footer .two.columns.support ul.footer_menu > li').eq(1).on('click', function () {
        openLiveChat();
        return false;
    });
    
    // hide multi product selector
    var productForm = $('.shopify-product-form');
    if (productForm.length >= 1) {
        var selectorWrappers = productForm.find('.selector-wrapper');
        selectorWrappers.each(function(i, el) {
            if (el.querySelector('label')) {
                if (el.querySelector('label').textContent ) {
                    var labelText = el.querySelector('label').textContent;
                    if (labelText === 'Color') {
                        el.style.display = "none";
                    }
                }
            }
        });
    }
    
    var currentPageWidth = $('body').width();
    if (currentPageWidth >= 1200) {
        var scrollDistance = 807;
    } else if ( (currentPageWidth > 767) && (currentPageWidth < 1200)) {
        var scrollDistance = 642;
    } else {
        var scrollDistance = 250;
    }
    
    
    $('.endless-list-scroll').on('click', function () {
        var direction = 'left';
        if ($(this).hasClass('go-right') === true) {
            direction = 'right';
        }
        
        if (direction === 'left') {
            var list = $(this).parent().next().find('.endless-list');
        } else {
            var list = $(this).parent().prev().find('.endless-list');
        }
                    
        var currentScrollDistance = list.scrollLeft();        
        var totalWidth = $('.products')[0].scrollWidth;
        
        if (direction === 'left') {
            var viewableWidth = $('.endless-list-container').width();
            if ( (totalWidth - currentScrollDistance) <= viewableWidth) {
                var newScrollDistance = currentScrollDistance - 179;    
            } else {
                var newScrollDistance = currentScrollDistance - scrollDistance;    
            }
        } else {
            var newScrollDistance = currentScrollDistance + scrollDistance;            
         }

        list.animate({
            scrollLeft: newScrollDistance
         }, 300);
        
        return false; 
    });
    
    var p;
    var currentQual; 
    var cartEnd;
    var globalID;
    var bar;
    
    var drawCartEnd = function () {
        if (currentQual === cartEnd || currentQual >= cartEnd) {
            cancelAnimationFrame(globalID);
        
          //clearInterval(interval);
          setTimeout(function () {
              var remaining = bar.data('remaining');
              if (remaining === 'FREE') {
                  p.html('&hearts; Your order ships FREE &hearts;');
              } else {
                  p.html('$' + remaining + ' until free shipping in the U.S.')
              }
          }, 750);
        }
    };
    
    var drawCountUp = function () {
        p.html(currentQual + '% qualified');
        currentQual++;
        globalID = requestAnimationFrame(drawCountUp);
        drawCartEnd();
    };
    
    // for cart page 
    // modified from 
    // https://codepen.io/AndrewHathaway/pen/vmuFk
    var initiateCartStuff = function () {
        bar = $('span.chart-bar').eq(0);
        if (bar.length === 0) {
            return false;
        }
        p = $('p.chart-text').eq(0);
        var width = bar.attr('style');
        
        width = width.replace("width:", "");
        width = width.substr(0, width.length-1);

        var start = 0; 
        cartEnd = parseInt(width);
        currentQual = start;

        var countUp = function() {
          currentQual++;
          var remaining = bar.data('remaining');
          
          if (cartEnd === 0) {
              var remaining = bar.data('remaining');
              p.html('$' + remaining + ' until free shipping in the U.S.');
              return false;
          } else {
              if (remaining === 'FREE') {
                  p.html('&hearts; Your order ships FREE &hearts;');
              } else {
                  p.html('$' + remaining + ' until free shipping in the U.S.')
              }
              //globalID = requestAnimationFrame(drawCountUp);
          }

        };
        countUp();
    };
    initiateCartStuff();
    
    // if ad-blockers are enabled that delete social links, just add them back in
    setTimeout(function () {
        if ($('#footer-social').is(":visible") === false && $('#mobile-footer-interactive .icon-instagram').is(":visible") === false ) {
            var simpleList = '<ul><li><a href="https://www.instagram.com/99tux/" target="_blank">Instagram</a></li><li><a href="https://www.facebook.com/99tux" target="_blank">Facebook</a></li><li><a href="https://www.youtube.com/channel/UCyBe9y2qSKy5R7_uWwCwm7Q/" target="_blank">YouTube</a></li><li><a href="https://twitter.com/99tux_com" target="_blank">Twitter</a></li></ul>';
            $('#footer-company').after('<div class="two columns footer-special-message-desktop"><h6><a href="/pages/our-commercials">Social</a></h6>' + simpleList + '</div>')
            $('#mobile-footer-interactive h6.social').after(simpleList);
            //$('#footer-company').after('<div class="two columns footer-special-message-desktop"><p>Hi. We totally understand and respect your decision to use an aggressive ad blocker. However, all we have here are links to our social media pages. We are a small, family run tuxedo company and we are only interested in selling you tuxedos, never your data. It is up to you, but we would kindly ask you to consider white-listing us in the tool you are using. Thank you.</p></div>')
            
        }
    }, 500);
    


});